import { translateLogMessage } from "@platko/shared/utils";
import type { LogMessage } from "@shared/types/payment";
import { useTranslation } from "react-i18next";
import * as liveLogsStyles from "./LiveLogs.styles";

const LogEntryRow = ({ entry }: { entry: LogMessage }) => {
  const { t } = useTranslation("backendLogs");
  const displayMessage = translateLogMessage(t, entry);
  return (
    <div className={liveLogsStyles.logEntry}>
      <span className={liveLogsStyles.timestamp}>{entry.timestamp}</span>
      {displayMessage}
    </div>
  );
};

export { LogEntryRow };
